import { isEqual } from "lodash";
export function restoreState(state, payload, slice) {
    if (!isEqual(state, payload[slice])) {
        return payload[slice];
    }
}
//# sourceMappingURL=utils.js.map